import api from '../backAxios';

class LinksTvService {
    async cadastrarLink(bodylink) {
        try {
            const envioLink = await api.post(
                'tv-telas/links',
                bodylink
            );

            return envioLink.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async putLink(bodylink,id) {
        try {
            const envioLink = await api.put(
                `tv-telas/links/${id}`,
                bodylink
            );

            return envioLink.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async getLinks() {
        try {
            const envioLink = await api.get(
                'tv-telas/links'
            );

            return envioLink.data;
        } catch (error) {
            throw new Error(error);
        }
    }
}

export default new LinksTvService();
